import React, { useEffect } from "react";
import Layout from "../compoents/Layout";
import {
  FaJsSquare,
  FaReact,
  FaJava,
  FaDocker,
  FaCcStripe,
  FaAppStore,
  FaFigma,
  FaNode,
  // FaAward
} from "react-icons/fa";
import AOS from "aos";

AOS.init({
  duration: 1000,
});
function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Layout>
   
      <div>
        {/* Intro section */}
        <div className="h-screen bg-theme">
          <div
            className="grid md:grid-cols-1 grid-cols-2 h-screen items-center border-4 md:border-0
            mx-10 z-10 bg-theme
          border-white transform rotate-0 md:rotate-0"
          >
            <div className="h-1/2">
              {/* <lottie-player
                src="https://assets4.lottiefiles.com/packages/lf20_7pzyukmv.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player> */}
              <lottie-player
                src="https://assets6.lottiefiles.com/packages/lf20_hlz9i1q4.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </div>

            <div className="font-bold text-white md:px-0 ">
              <h1 className="text-5xl md:text-4xl" data-aos="slide-right">
                Build. Deliver. Grow.
                <h1 className="text-red-400 px-10 text-sm">with</h1>
                <h1 className="text-yellow-500 text-left">TECHNOFORGEN</h1>
              </h1>
              <h1 className="text-xl md:text-l py-10" data-aos="slide-left">
                Deliver tasks as a team or as an individual.
              </h1>
            </div>
          </div>
        </div>

        {/* Technologies */}

        <div className="mt-20">
          <h1
            className="text-4xl text-blue-800 font-bold text-center my-8"
            data-aos="slide-up"
          >
            Technologies We USE
          </h1>
          <div className="grid md:grid-cols-1 grid-cols-4">
            <FaReact
              size={120}
              color="cyan"
              className="w-full text-center mt-20 animate-spin"
            />
            <FaCcStripe
              size={120}
              color="red"
              className="w-full text-center mt-20 animate-bounce"
            />
            <FaJava
              size={120}
              color="orange"
              className="w-full text-center mt-20 animate-bounce"
            />
            <FaNode
              size={120}
              color="green"
              className="w-full text-center mt-20 animate-pulse"
            />
            <FaAppStore
              size={120}
              color="blue"
              className="w-full text-center mt-20 animate-bounce"
            />
            <FaJsSquare
              size={120}
              color="green"
              className="w-full text-center mt-20 animate-pulse"
            />
            <FaDocker
              size={120}
              color="orange"
              className="w-full text-center mt-20 animate-bounce"
            />
            <FaFigma
              size={120}
              color="blue"
              className="w-full text-center mt-20 animate-bounce"
            />
          </div>
        </div>

        {/* {Javscript Buff} */}
        <div className="my-20">
          <div className="text-center h-52 bg-primary">
            <h1 className="text-black font-bold text-2xl py-10">
              Our Mission & Vision
            </h1>
          </div>

          <div className="md:mx-5 mx-32 shadow-2xl bg-gray-50 -mt-20 rounded-lg hover:bg-gray-700 hover:text-white">
            <div className="h-96" data-aos="zoom-in">
              <lottie-player
                src="https://assets3.lottiefiles.com/packages/lf20_6bgnnlrr.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </div>

            <p className="text-l text-justify md:text-left my-0 font-semibold md:py-5 px-14 py-10 md:indent-4">
              <h1 className="text-xl font-bold text-yellow-500 mx-10 pb-5 md:text-justify sm:text-clip text-overflow: clip ">
                Mission
              </h1>
              <br />
              <li>
                Technoforgens mission is to deliver world class IT solutions for
                varied industry verticals by maximizing value & growth in both
                our customer’s & our business; our customer & our people being
                the two most important stakeholders of the company.
              </li>{" "}
              <br />
              <h1 className="text-xl font-bold text-yellow-500 mx-10 pb-5 md:text-center ">
                Vision
              </h1>
              <hr className="pb-5" />
              <li>
                We achieve this by continuously nurturing innovation, talent,
                cost-effectiveness, technological excellence & practicing global
                processes.
              </li>{" "}
              <br />
              <li>
                To be a Globally recognised Customer Centric Supply Chain
                Solutions Company that improves Customer competitiveness. Build
                innovative products using latest technology that are easy to use
                and have rich functionality.
              </li>{" "}
              <br />
              <li>
                Attract, retain and develop best talent in the industry.
              </li>{" "}
            </p>

            <p className="text-l my-10 font-semibold md:px-5 px-14 py-10"></p>
          </div>
        </div>

        {/* {Dev stack section} */}
        <div className="my-20">
          <div className="text-center h-52 bg-red-500">
            <h1 className="text-black font-bold text-2xl py-10">
              End to End solution for your application
            </h1>
          </div>

          <div className="md:mx-5 mx-32 shadow-2xl bg-gray-50 -mt-20 rounded-lg hover:bg-gray-700 hover:text-white">
            <div className="h-96" data-aos="zoom-in">
              <lottie-player
                src="https://assets9.lottiefiles.com/packages/lf20_0fG6TX.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </div>

            <div className="grid md:grid-cols-1 grid-cols-3 p-5">
              <div>
                <h1 className="text-xl font-bold text-yellow-500 mx-10  md:text-center ">
                  Web Applications
                </h1>
                <hr />
                <p className="font-semibold mt-2">
                  <li>Integration with other applications </li>
                </p>

                <p className="font-semibold mt-2">
                  <li>24/7 customer service </li>
                </p>
                <p className="font-semibold mt-2">
                  <li>Order tracking & Sales report</li>
                </p>
                <p className="font-semibold mt-2">
                  <li>Invoice generation & Customization </li>
                </p>
              </div>

              <div className="text-center">
                <h1 className="text-xl font-bold text-yellow-500 mx-10  md:text-center">
                  UI/UX
                </h1>
                <hr />
                <p className="font-semibold mt-2 text-left ">
                  {" "}
                  <li>Enhance a customer's experience</li>
                </p>

                <p className="font-semibold mt-2 text-left ">
                  {" "}
                  <li>Prototype before you build a real</li>
                </p>

                <p className="font-semibold mt-2 text-left">
                  {" "}
                  <li>Keep things simple & consistent</li>
                </p>
              </div>

              <div className="text-right">
                <h1 className="text-xl font-bold text-yellow-500 mx-10 text-justify  md:text-center">
                  Mobile Apps
                </h1>
                <hr />
                <p className="font-semibold mt-2 text-left ">
                  <li>Deliver projects on time </li>
                </p>
                <p className="font-semibold mt-2 text-left ">
                  <li>Excellent Technical Support</li>
                </p>

                <p className="font-semibold mt-2 text-left ">
                  <li>100% Transparency </li>
                </p>
                <p className="font-semibold mt-2 text-left ">
                  <li>Flexible Engagements </li>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Home;
